import { render } from "./ToDoList.vue?vue&type=template&id=00cb964c&ts=true"
import script from "./ToDoList.vue?vue&type=script&lang=ts"
export * from "./ToDoList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__